"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
  
import FB from "../public/sm1.svg";
import Twitter from "../public/sm2.svg";
import LinkedIn from "../public/sm3.svg";
import Ticktok from "../public/sm4.svg";
import Youtube from "../public/sm5.svg";
import Telegram  from "../public/sm6.svg"; 
import Insta  from "../public/sm7.svg"; 

const FooterSection = () => {
  const pathname = usePathname();

  return (
    <footer className="text-white pt-5 pb-3 footerMain">
      <Container>
        <Row className="gy-4 align-items-start">
          {/* ---------- Left Section ---------- */}
          <Col md={12} lg={5}>
            <Link
             href="https://appran.com/" target="_blank"
              className="fw-bold fs-2 text-decoration-none text-white d-block mb-2  "
            >
              appran.
             {/* <Image src={Logo} width={60} height={60} alt="AppRan" priority /> */}
            </Link>

            <p className="text-uppercase small text-white opacity-50 mb-3">
              Subscribe to our newsletter
            </p>

            <Form className="input-group mb-4">
              <Form.Control
                type="email"
                placeholder="Enter Your Email"
                className="me-2 rounded-pill bg-transparent text-white border border-primary py-3 px-4"
              />
              <Button
                type="submit"
                className="rounded-pill px-4 fw-semibold btn-gradient text-white d-block"
              >
                <span className="d-block">Subscribe</span>
              </Button>
            </Form>

            <div className="d-flex gap-3 flex-wrap mb-3 socialIcons">
              <Link href="https://www.facebook.com/AppranOfficial" target="_blank">
                <Image src={FB} alt="Facebook" width={28} height={28} />
              </Link>
              <Link href="https://x.com/AppRanTalks" target="_blank">
                <Image src={Twitter} alt="Twitter" width={28} height={28} />
              </Link>
              <Link href="https://www.linkedin.com/company/appran" target="_blank">
                <Image src={LinkedIn} alt="LinkedIn" width={28} height={28} />
              </Link>
              <Link href="https://www.tiktok.com/@appranofficial" target="_blank">
                <Image src={Ticktok} alt="TikTok" width={28} height={28} />
              </Link>
              <Link href="https://www.youtube.com/@apprantalks" target="_blank">
                <Image src={Youtube} alt="YouTube" width={28} height={28} />
              </Link>
              <Link href="https://t.me/Apprantalks" target="_blank">
                <Image src={Telegram} alt="Telegram" width={28} height={28} />
              </Link>
              <Link href="https://www.instagram.com/apprantalks" target="_blank">
                <Image src={Insta} alt="Instagram" width={28} height={28} />
              </Link>
            </div>

            <Link
              href="https://calendly.com/admin-appran/appran-intro-meeting"
              className={`btn btn-lg btn-gradient rounded-pill py-3 px-5 fw-bold mx-2 my-3 btnSolid`}
              target="_blank"
            >
              <span className="text-white fs-6 fw-semibold">Book a Meeting</span>
            </Link>

            <p className="text-white opacity-50 p-0 m-0 mt-0  fs-6">Email: </p>
            <p className="text-white  fs-6">admin@appran.com</p>
          </Col>

          {/* ---------- Middle Links Section ---------- */}
          <Col md={12} lg={7}>
            <Row className="gy-4">
              <Col xs={6} md={4}>
                <ul className="list-unstyled-zero small footerLinks">
                  <li><Link href="/applesearchads">Apple Search Ads</Link></li>
                  {/* <li><Link href="/appreviews&ratings">App Reviews & Ratings</Link></li> */}
                  <li><Link href="https://appran.com/redditads">Reddit Mobile Ads</Link></li>
                  <li><Link href="https://appran.com/facebookads">Facebook Mobile Ads</Link></li>
                  <li><Link href="https://appran.com/tiktokads">TikTok Mobile Ads</Link></li>
                  <li><Link href="https://appran.com/ugcvideoads">UGC Video Ads</Link></li>
                </ul>
              </Col>

              <Col xs={6} md={4}>
                <ul className="list-unstyled-zero small footerLinks">
                  <li><Link href="/#packages-section">App Store Optimization</Link></li>
                  {/* <li><Link href="/#buy-section">App Installs</Link></li> */}
                  <li><Link href="https://appran.com/#testimonials-section">Testimonials</Link></li>
                  <li><Link href="https://appran.com/instagrammobileads">Instagram Mobile Ads</Link></li>
                  <li><Link href="https://appran.com/googleads">Google Mobile Ads</Link></li>
                  <li><Link href="https://appran.com/skanaudit">SKAN 4.0 Audit</Link></li>
                </ul>
              </Col>

              <Col xs={12} md={4}>
                <ul className="list-unstyled-zero small footerLinks">
                  <li><Link href="https://blog.appran.com">Blog</Link></li>
                  <li><Link href="https://case-studies.appran.com">Case Studies</Link></li>
                  <li><Link href="https://solutions.appran.com">Solutions</Link></li>
                  <li><Link href="https://glossary.appran.com">Glossary</Link></li>
                  <li><Link href="https://appran.com/pricing">Pricing</Link></li>
                  <li><Link href="/#faq-section">FAQs</Link></li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>

        <hr className="border-secondary my-4" />

        {/* ---------- Bottom Section ---------- */}
        <div className="d-flex justify-content-between flex-wrap small text-white-50">
          <p className="mb-0 small fs-6">
            Copyright © · All Rights Reserved ·{" "}
            <span className="fw-semibold text-white">AppRan</span>
          </p>
          <p className="mb-0 footerLinks">
            <Link href="https://appran.com/termsconditions" className="small d-inline-block">Terms & Conditions</Link> |{" "}
            <Link href="https://appran.com/privacypolicy" className="small d-inline-block">Privacy Policy</Link>
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default FooterSection;
